"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var PillContainer = function PillContainer(_ref) {
  var children = _ref.children;
  return (0, _preact.h)("div", {
    className: "preact-pill-container"
  }, children);
};

var _default = PillContainer;
exports.default = _default;